<template>
  <article class="relative md:pl-6 md:pt-6 xl:pt-9 xl:pl-9">
    <div :class="benefit?.icon" class="text-dark text-4xl z-0 mb-2" />
    <div class="relative space-y-4 z-20">
      <template v-if="!benefit.link">
        <p class="text-dark text-xl font-semibold">
          {{ $t(benefit?.title) }}
        </p>
      </template>
      <template v-else>
        <a
          :href="benefit.link"
          target="_blank"
          class="text-green text-xl font-semibold transition-colors hover:text-green-700"
        >
          {{ $t(benefit?.title) }}
        </a>
      </template>
      <p class="text-gray">{{ $t(benefit?.desc) }}</p>
    </div>
  </article>
</template>

<script setup lang="ts">
interface Props {
  benefit: {
    title: string;
    desc: string;
    icon: string;
    link?: string;
  };
}
defineProps<Props>();
</script>

<style scoped></style>
